import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import MeetingLibrary from './pages/MeetingLibrary';
import MeetingConsole from './pages/MeetingConsole';
import ActionItems from './pages/ActionItems';
import Settings from './pages/Settings';
import Guide from './pages/Guide';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Dashboard />} />
          <Route path="library" element={<MeetingLibrary />} />
          <Route path="console/:id" element={<MeetingConsole />} />
          <Route path="actions" element={<ActionItems />} />
          <Route path="guide" element={<Guide />} />
          <Route path="settings" element={<Settings />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;